export default "__VITE_ASSET__DnPeICTz__"